export default class NavMain {
  constructor() {
    this.selector = '.nav-main';
    this.navDropdownParent = '.nav-main > li';

    this.className = {
      active: 'menu-item--active',
      dropdownParent: 'menu-item-has-children',
      dropdownArrow: 'menu-item__arrow',
    };

    this.selectors = {
      subMenu: '.sub-menu',
    };
  }

  bootstrap() {
    this.init();
  }

  init() {
    const items = [ ...document.querySelectorAll(this.navDropdownParent) ];

    if (items.length === 0) {
      return;
    }

    this.appendArrows({ items });
    this.handleClicks({ items });
  }

  appendArrows({ items }) {
    items.forEach(item => {
      if (item.classList.contains(this.className.dropdownParent)) {
        item.querySelector('a').appendChild(this.createArrow());
      }
    });
  }

  createArrow() {
    const arrow = document.createElement('span');

    arrow.classList.add(this.className.dropdownArrow);

    return arrow;
  }

  handleClicks({ items }) {
    items.forEach(item => {
      item.addEventListener('click', event => {
        if (event.target.closest(this.selectors.subMenu)) {
          return;
        }

        this.toggleElementClass({ items, item });
      });
    });
  }

  toggleElementClass({ items, item }) {
    items.forEach(element => {
      if (element !== item) {
        element.classList.remove(this.className.active);
      }
    });

    if (this.isSubMenuOpen({ item })) {
      item.classList.remove(this.className.active);

      return;
    }

    item.classList.add(this.className.active);
  }

  isSubMenuOpen({ item }) {
    return item.classList.contains(this.className.active);
  }
}
